import { Box, BoxProps, Tooltip, UnstyledButton, rem } from '@mantine/core';
import { Link, LinkProps } from '@tanstack/react-router';

import styles from './navbar-link.module.css';

interface NavbarLinkProps {
  icon: React.FC<any>;
  label: string;
  to: LinkProps['to'];
  active?: boolean;
  onClick?(): void;
  hiddenFrom?: BoxProps['hiddenFrom'];
  visibleFrom?: BoxProps['visibleFrom'];
  /** Small corner tag (e.g. "WIP") on the icon button. */
  cornerBadge?: string;
}

export function NavbarLink({
  icon: Icon,
  label,
  active,
  to,
  cornerBadge,
  ...boxProps
}: NavbarLinkProps) {
  return (
    <Box {...boxProps}>
      <Tooltip label={label} position="right" transitionProps={{ duration: 0 }}>
        <div className={styles.iconWrap}>
          <UnstyledButton
            className={styles.link}
            component={Link}
            data-active={active || undefined}
            to={to}
          >
            <Icon stroke={'1.5'} style={{ width: rem(20), height: rem(20) }} />
          </UnstyledButton>
          {cornerBadge ? (
            <span className={styles.wipBadge}>{cornerBadge}</span>
          ) : null}
        </div>
      </Tooltip>
    </Box>
  );
}

export default NavbarLink;
